var _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTractor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.6,7.8c-0.2-0.6-0.6-1.1-0.9-1.7c0-0.1,0-0.1,0.1-0.1C10.9,6,11,6,11,6.1c0.4,0.5,0.7,1.1,0.9,1.7 c0,0,0,0.1-0.1,0.1L11.6,7.8C11.7,7.8,11.6,7.8,11.6,7.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M9.9,6.4c-0.3,0-0.5-0.1-0.5-0.3s0.1-0.4,0.3-0.5c0.2-0.1,0.5-0.3,0.8-0.4C10.8,5,11.2,5,11.4,5 c0.3,0,0.5,0.1,0.5,0.3c0,0.2-0.1,0.4-0.3,0.5c-0.2,0.2-0.5,0.3-0.8,0.4S10.2,6.3,9.9,6.4C10,6.4,9.9,6.4,9.9,6.4z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.8,14.6c0.2-1.1,0.3-3.2-1.7-4.8C6.5,7.7,3,10.2,3,10.2L2,9.1c4.8-4,9.3-0.4,9.3-0.4l-1-1.9h1.6L13,8.7 h9.3C22.7,8.7,23,9,23,9.4v5.3c0,0.3-0.2,0.5-0.5,0.5H11.3C11,15.2,10.7,14.9,10.8,14.6z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10.1,
    y: 10.8,
    style: {
      fill: "#000"
    },
    width: 12.9,
    height: 0.7
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.9,
    y: 5.9,
    width: 0.7,
    height: 2.8
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "19.3,5.2 19.9,5.9 20.5,5.9 21.2,5.2  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 6.5,
    cy: 13.5,
    r: 4.8
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M5.7,18.6c0-0.4,0.3-0.5,0.6-0.5c0.5,0,0.9,0,1.4,0.1c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0,0.2-0.1,0.3 C7.5,19,7.5,19,7.4,19C7.1,19,6,19,5.7,18.6L5.7,18.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M3,17.5c0.1-0.3,0.5-0.3,0.7-0.2c0.4,0.2,0.8,0.4,1.2,0.7c0,0.1,0,0.3,0,0.4s-0.1,0.2-0.3,0.2 c-0.1,0-0.2,0-0.3,0C4.1,18.5,3.1,18,3,17.5L3,17.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1.4,15.2c0.3-0.2,0.5,0,0.7,0.2c0.3,0.4,0.5,0.8,0.7,1.2c-0.1,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2C1.9,16.5,1.2,15.6,1.4,15.2C1.3,15.3,1.3,15.2,1.4,15.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1.4,12.5c0.3,0,0.5,0.3,0.5,0.5c0,0.4,0,0.9,0,1.4c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1 c0-0.1-0.1-0.2-0.1-0.3c0-0.3-0.2-1.4,0.1-1.7C1.2,12.5,1.2,12.5,1.4,12.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M2.4,9.9c0.3,0.1,0.3,0.4,0.2,0.7C2.5,11,2.3,11.5,2,11.9c-0.1,0-0.2,0-0.4,0c-0.1,0-0.2-0.1-0.3-0.2 c0-0.1,0-0.2,0-0.3c0.1-0.3,0.4-1.3,0.8-1.5C2.3,9.9,2.4,9.9,2.4,9.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M4.9,8.4C5,8.7,4.9,9,4.6,9.1C4.2,9.4,3.8,9.6,3.4,9.8c-0.1,0-0.2-0.1-0.3-0.2c0-0.1-0.1-0.2,0-0.3 c0-0.1,0.1-0.2,0.2-0.2C3.5,9,4.4,8.3,4.9,8.4C4.8,8.3,4.8,8.4,4.9,8.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M7.9,8.4c0,0.4-0.3,0.4-0.6,0.4c-0.5,0-0.9-0.1-1.4-0.2c0-0.1-0.1-0.2-0.1-0.4S5.9,8.1,6,8 c0,0,0.1,0,0.2,0C6.5,8,7.6,8,7.9,8.4C7.9,8.3,7.9,8.4,7.9,8.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M10.5,10c-0.1,0.3-0.5,0.2-0.7,0.1C9.4,9.8,9,9.6,8.6,9.3c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.2,0.3-0.2 c0.1,0,0.2,0,0.3,0.1C9.6,8.9,10.5,9.5,10.5,10C10.5,9.9,10.5,10,10.5,10z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.8,12.9c-0.3,0.1-0.6-0.1-0.7-0.4c-0.2-0.4-0.4-0.9-0.5-1.3c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0,0.3,0,0.4,0 c0.1,0,0.1,0.1,0.2,0.2c0.1,0.2,0.6,1.2,0.4,1.6C11.8,12.8,11.8,12.8,11.8,12.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.2,15.8c-0.3-0.1-0.4-0.4-0.4-0.7c0.1-0.4,0.2-0.9,0.4-1.4c0.1,0,0.2,0,0.4,0s0.3,0,0.3,0.2 c0,0.1,0,0.2,0,0.3c0,0.3-0.2,1.4-0.5,1.6C11.3,15.7,11.2,15.8,11.2,15.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M9.1,18.2C8.9,18,9,17.6,9.2,17.5c0.3-0.3,0.7-0.6,1.1-0.9c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.1,0.3 c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.2-0.9,1-1.3,1C9.2,18.2,9.1,18.2,9.1,18.2z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 13.5,
    r: 2.2
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 6.5,
    cy: 13.5,
    r: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 19.2,
    cy: 15.5,
    r: 2.8
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M20.5,12.5c0,0.4-0.3,0.5-0.6,0.5c-0.5,0-0.9,0-1.4-0.1c0-0.1-0.1-0.2-0.1-0.4c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.2-0.1,0.3-0.1c0.3,0,1.4-0.1,1.6,0.2C20.4,12.4,20.4,12.5,20.5,12.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.5,12.8c0.3,0.2,0.2,0.5,0,0.7c-0.3,0.4-0.6,0.7-1,1.1c-0.1,0-0.3,0-0.4-0.1C16,14.4,16,14.3,16,14.2 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.8-1.1,1.2-1.1C17.4,12.7,17.4,12.7,17.5,12.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15.8,15.4c0.3-0.2,0.6,0,0.7,0.3c0.2,0.4,0.4,0.9,0.5,1.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0-0.3,0-0.4,0 s-0.1-0.1-0.2-0.2c-0.1-0.2-0.7-1.2-0.5-1.6C15.7,15.5,15.7,15.4,15.8,15.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.2,18.1c0.1-0.3,0.4-0.4,0.7-0.3c0.5,0.1,0.9,0.3,1.4,0.4c0,0.1,0.1,0.3,0,0.4c0,0.1-0.1,0.2-0.2,0.3 c-0.1,0-0.2,0-0.3,0c-0.3,0-1.4-0.3-1.5-0.6C17.2,18.2,17.2,18.1,17.2,18.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.9,18.6c-0.2-0.3,0-0.5,0.2-0.7c0.4-0.3,0.8-0.5,1.2-0.7c0.1,0.1,0.2,0.1,0.3,0.2s0.1,0.2,0.1,0.4 c0,0.1-0.1,0.2-0.2,0.2C21.3,18.1,20.4,18.8,19.9,18.6C20,18.7,19.9,18.6,19.9,18.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M22.1,16.9c-0.3,0-0.4-0.3-0.4-0.6c0-0.5,0-0.9,0.1-1.4c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.2,0,0.3,0.1 c0,0.1,0,0.2,0,0.3C22.5,15.5,22.5,16.6,22.1,16.9C22.2,16.9,22.2,16.9,22.1,16.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M22.3,14.3c-0.2,0.2-0.5,0.1-0.7-0.1c-0.4-0.4-0.6-0.7-0.9-1.1c0-0.1,0.1-0.2,0.2-0.3 c0-0.1,0.2-0.2,0.3-0.1c0.1,0,0.2,0.1,0.2,0.2C21.6,13.1,22.4,13.9,22.3,14.3C22.4,14.2,22.3,14.2,22.3,14.3z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 19.2,
    cy: 15.5,
    r: 1.7
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 19.2,
    cy: 15.5,
    r: 0.7
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractor);
export default __webpack_public_path__ + "static/media/tractor.6105adec16711769feb72bea37a23e3b.svg";
export { ForwardRef as ReactComponent };